var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84347 17.1566C5.93895 16.2521 5.94862 14.778 6.8651 13.8615L10.1237 10.6029L8.93202 9.41124L5.67343 12.6698C4.08778 14.2555 4.07108 16.7991 5.63604 18.3641C7.20101 19.929 9.74463 19.9123 11.3303 18.3267L14.5889 15.0681L13.3972 13.8764L10.1386 17.135C9.22213 18.0515 7.74799 18.0612 6.84347 17.1566ZM10.2413 8.10199L11.4329 9.29366L14.6915 6.03508C15.608 5.1186 17.0822 5.10892 17.9867 6.01344C18.8912 6.91796 18.8815 8.39211 17.965 9.30859L14.7065 12.5672L15.8981 13.7588L19.1567 10.5003C20.7424 8.91461 20.7591 6.37099 19.1941 4.80602C17.6291 3.24105 15.0855 3.25775 13.4999 4.8434L10.2413 8.10199ZM8.96737 15.0327C9.29759 15.363 9.84678 15.3594 10.1814 15.0248L15.8694 9.33679C16.2039 9.00221 16.2075 8.45302 15.8773 8.12279C15.5471 7.79257 14.9979 7.79618 14.6633 8.13077L8.97534 13.8187C8.64075 14.1533 8.63715 14.7025 8.96737 15.0327Z",
    fill: "#8688A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/share-link.d478a47b.svg";
export { ForwardRef as ReactComponent };